import { render, staticRenderFns } from "./addactivity.vue?vue&type=template&id=96ce988a&scoped=true"
import script from "./addactivity.vue?vue&type=script&lang=js"
export * from "./addactivity.vue?vue&type=script&lang=js"
import style0 from "./addactivity.vue?vue&type=style&index=0&id=96ce988a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce988a",
  null
  
)

export default component.exports